<template>
  <div style="background: #fff;">
    <div class="common-store-wrapper">
      <div class="common-store-header-nav">
        <span style="color: #000000;">店铺</span><span>&nbsp;&nbsp;>&nbsp;&nbsp;</span><span style="color:#B6B6B6">{{ storeName }}</span>
      </div>
      <div class="common-store-search">
        <div class="common-store-search-type">
          <div style="width:100px;color:#B6B6B6">店铺类型：</div>
          <div
            class="search-type-item"
            :class="storeType=='2' ? 'search-type-store-active' : ''"
            @click="storeTypeHandle('2')"
          >企业店铺</div>
          <div
            class="search-type-item"
            :class="storeType=='4' ? 'search-type-store-active' : ''"
            @click="storeTypeHandle('4')"
          >金牌店铺</div>
          <div
            class="search-type-item"
            :class="storeType=='5' ? 'search-type-store-active' : ''"
            @click="storeTypeHandle('5')"
          >银牌店铺</div>
          <div
            class="search-type-item"
            :class="storeType=='1' ? 'search-type-store-active' : ''"
            @click="storeTypeHandle('1')"
          >个体店铺</div>
          <div
            class="search-type-item"
            :class="storeType=='' ? 'search-type-store-active' : ''"
            @click="storeTypeHandle('')"
          >不限</div>
        </div>
        <div class="common-store-search-type">
          <div style="width:100px;color:#B6B6B6">好评率：</div>
          <div
            class="search-type-item"
            :class="praiseRateType==1 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(1)"
          >100%</div>
          <div
            class="search-type-item"
            :class="praiseRateType==2 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(2)"
          >99%以上</div>
          <div
            class="search-type-item"
            :class="praiseRateType==3 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(3)"
          >98%以上</div>
          <div
            class="search-type-item"
            :class="praiseRateType==4 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(4)"
          >97%以上</div>
          <div
            class="search-type-item"
            :class="praiseRateType==5 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(5)"
          >96%以上</div>
          <div
            class="search-type-item"
            :class="praiseRateType==6 ? 'search-type-hp-active' : ''"
            @click="praiseRateTypeHandle(6)"
          >不限</div>
        </div>
      </div>
      <div class="common-store-sort">
        <div class="common-store-sort-left">
          <div
            class="common-store-sort-left-item"
            :class="sortType==0 ? 'store-sort-active' : ''"
            @click="sortTypeHandle(0)"
          >综合排序</div>
          <div
            class="common-store-sort-left-item"
            :class="sortType==1 ? 'store-sort-active' : ''"
            @click="sortTypeHandle(1)"
          >销量</div>
          <div
            class="common-store-sort-left-item"
            :class="sortType==2 ? 'store-sort-active' : ''"
            @click="sortTypeHandle(2)"
          >信用</div>
        </div>
        <div class="hasCollect-sty">
          <el-checkbox
            v-model="hasCollect"
            @change="hasCollectChange"
            label="收藏"
          ></el-checkbox>
        </div>
      </div>
      <div
        class="common-store-box"
        v-for="(item, index) in storeList"
        :key="index"
      >
        <div class="common-store-box-title">
          <div class="common-store-box-title-left" @click="gotoShop(item)">
            <el-image
              style="width: 82px; height: 82px;border-radius: 8px;"
              fit="cover"
              :src="item.storeLogo || require('./../../../static/tyjf.png')"
            ></el-image>
            <div style="margin-left: 30px;">
              <div style="color: #313131;font-size: 20px;">{{ item.storeName }}</div>
              <div style="color: #9D9D9D;">{{ item.praiseRate * 100 + '%' }}</div>
            </div>
          </div>
          <div
            v-show="!item.hasCollect"
            class="common-store-box-title-right"
            @click="addCollection(item, index)"
          >
            关注
          </div>
          <div
            v-show="item.hasCollect"
            class="common-store-box-title-right"
            style="background: #B6B6B6;"
            @click="favoriteDelete(item, index)"
          >
            已关注
          </div>
        </div>
        <div class="common-store-box-list">
          <div
            v-if="item.storeGoodsVoList.length > 0"
            style="width: 100%;height: 100%; display: flex;"
          >
            <div
              style="margin-right: 24px"
              class="common-store-box-list-item"
              v-for="(v,k) in item.storeGoodsVoList"
              :key="k"
              @click="gotoPage(v)"
            >
              <el-image
                style="height: 256px;border-radius: 10px 10px 0 0;"
                fit="cover"
                :src="v.thumbnail"
              ></el-image>
              <div style="color: #393939;text-align: center;">
                {{ v.name }}
              </div>
              <div style="color: #EE1C25;font-size: 20px;text-align: center;">
                ￥{{ v.price }}
              </div>
            </div>
          </div>

          <div
            v-else
            style="color:rgb(157, 157, 157)"
          >
            暂无商品
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import _ from "lodash";
import { Image, Checkbox } from "element-ui";
import { getStoreSearch } from "api/user";
import { favoriteAdd, favoriteDelete } from "api/goods.js";
export default {
  data() {
    return {
      storeType: "4",
      storeName: "金牌网店",
      praiseRateType: 6,
      sortType: 0,
      hasCollect: false,
      pageNo: 1,
      searchInfo: {
        hasCollect: false,
        pageNo: 1,
        pageSize: 10,
        praiseRateType: 6,
        sortType: 0,
        storeType: "4",
      },
      storeList: [],
      hasMore: true,
    };
  },
  components: {
    [Image.name]: Image,
    [Checkbox.name]: Checkbox,
  },
  created() {
    this.storeType = this.$route.query.storeType;
    this.getStoreName(this.storeType);
    this.getStoreSearch();
  },
  mounted() {
    window.addEventListener("scroll", _.throttle(this.bindScroll, 1000));
  },
  destroyed() {
    $(window).unbind("scroll");
  },
  deactivated() {
    $(window).unbind("scroll");
  },
  methods: {
    bindScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        this.getStoreSearch();
      }
      // if (scrollTop + windowHeight + 450 >= scrollHeight && this.hasMore) {
      //   this.getStoreSearch();
      // }
    },
    getStoreSearch() {
      this.searchInfo.praiseRateType = this.praiseRateType;
      this.searchInfo.sortType = this.sortType;
      this.searchInfo.storeType = this.storeType;
      this.searchInfo.hasCollect = this.hasCollect;
      this.searchInfo.pageNo = this.pageNo;
      if (this.hasMore) {
        getStoreSearch(this.searchInfo).then((res) => {
          if (res.resCode == 1) {
            let data = res.data;
            this.hasMore = data.hasMore;
            if (this.hasMore) {
              this.pageNo = this.pageNo + 1;
            }
            let storeList = data.list || [];
            let temp = this.storeList;
            this.storeList = temp.concat(storeList);
          }
        });
      }
    },

    getStoreName(type) {
      switch (type) {
        case "4":
          this.storeName = "金牌网店";
          break;
        case "1":
          this.storeName = "个体网店";
          break;
        case "2":
          this.storeName = "企业网店";
          break;
        case "5":
          this.storeName = "银牌网店";
          break;
        case "":
          this.storeName = "不限";
          break;
      }
    },
    // 店铺类型切换
    storeTypeHandle(type) {
      this.storeList = [];
      this.pageNo = 1;
      this.hasMore = true;
      this.storeType = type;
      this.getStoreName(this.storeType);
      this.getStoreSearch();
    },

    // 好评切换
    praiseRateTypeHandle(type) {
      this.storeList = [];
      this.pageNo = 1;
      this.hasMore = true;
      this.praiseRateType = type;
      this.getStoreSearch();
    },

    // 	排序切换
    sortTypeHandle(type) {
      this.storeList = [];
      this.pageNo = 1;
      this.hasMore = true;
      this.sortType = type;
      this.getStoreSearch();
    },

    hasCollectChange() {
      this.storeList = [];
      this.pageNo = 1;
      this.hasMore = true;
      this.getStoreSearch();
    },

    addCollection(item, index) {
      if (this.$store.getters.sid == "" || !this.$store.getters.sid) {
        this.$Message.info("请先登录");
      } else {
        let data = {
          storeId: item.storeId,
          type: 2,
        };
        favoriteAdd(data).then((json) => {
          if (json.resCode == "1") {
            let obj = item;
            item.hasCollect = true;
            this.$set(this.storeList, index, obj);
            this.$Message.info("关注成功");
          } else {
            this.$Message.info(json.resDesc);
          }
        });
      }
    },

    favoriteDelete(item, index) {
      let data = {
        storeId: item.storeId,
        type: 2,
      };
      favoriteDelete(data).then((json) => {
        if (json.resCode == "1") {
          let obj = item;
          item.hasCollect = false;
          this.$set(this.storeList, index, obj);
          this.$Message.info("取关成功");
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },

    gotoPage(item) {
      let text = this.$router.resolve({
        path: `/goods?goods_id=${item.goodsId}`,
      });
      window.open(text.href, "_blank");
    },

    gotoShop(item) {
      let text = this.$router.resolve({
        path: `/shop?tab=2&store_id=${item.storeId}`,
      });
      window.open(text.href, "_blank");
    },
  },
};
</script>

<style scoped>
.common-store-wrapper {
  width: 1226px;
  margin: 0 auto;
  font-size: 16px;
  /* background: #fff; */
}
.common-store-header-nav {
  height: 80px;
  line-height: 80px;
  margin-left: 30px;
}
.common-store-search {
  height: 130px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #dadada;
}
.common-store-search-type {
  margin: 0 30px;
  display: flex;
  border-bottom: 1px solid #dadada;
  padding: 14px 0;
}
.search-type-item {
  width: 120px;
  color: #313131;
  cursor: pointer;
}
.search-type-store-active {
  color: #ec671a;
}
.search-type-hp-active {
  color: #ec671a;
}
.common-store-sort {
  padding: 0 30px;
  height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.common-store-sort-left {
  display: flex;
  color: #313131;
  cursor: pointer;
}
.common-store-sort-left-item {
  margin-right: 50px;
}
.store-sort-active {
  color: #ec671a;
}
.common-store-box {
  padding: 56px 72px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #dadada;
  margin-bottom: 58px;
}
.common-store-box-title {
  height: 118px;
  border-bottom: 1px solid #dadada;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}
.common-store-box-title-left {
  display: flex;
  cursor: pointer;
}
.common-store-box-title-right {
  width: 110px;
  border-radius: 20px;
  background: #ea2436;
  text-align: center;
  line-height: 40px;
  height: 40px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.common-store-box-list {
  margin-top: 76px;
  display: flex;
  justify-content: space-around;
}
.common-store-box-list-item {
  width: 192px;
  cursor: pointer;
}
.hasCollect-sty .el-checkbox__label {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// index.vue?d7aab5b8